<script setup lang="ts">
	import StringMethods from '~/utils/character'

	export type PlanAnalysisContext = Record<
		string,
		{
			label?: string
			total: string | number
			iconDir: string
			icon: string
			tooTipMessage: string
			disabled?: boolean
		}
	>
	defineProps<{
		title: string
		analysis: PlanAnalysisContext
	}>()

	const replace = StringMethods()
	const { internationalNoFormat } = useCurrency()
</script>

<template>
	<div class="w-full border-b">
		<h4 class="mb- text-lg font-medium text-blue-950">
			{{ title }}
		</h4>

		<div class="mb flex flex-wrap items-center justify-between gap-4 border-b border-gray-50 lg:flex-nowrap">
			<template v-for="(item, k) in analysis" :key="k">
				<div v-if="!item.disabled" class="flex items-center gap-4 py-7">
					<span
						class="flex h-[24px] w-[24px] items-center justify-center rounded-full border border-purple-100 bg-purple-25"
					>
						<lazy-tools-icon
							:dir="item.iconDir"
							:icon="item.icon"
							path-class="fill-purple-500"
							:width="12"
							:height="12"
						/>
					</span>

					<div>
						<a-tooltip color="#fff">
							<div class="text-xs text-gray-600">
								{{ k || item.label }}
							</div>
							<template #title>
								<div
									class="p-2 font-medium text-gray-500"
									v-html="
										replace.replacePlaceholder(item.tooTipMessage, (k || item?.label) as string)
									"
								/>
							</template>
						</a-tooltip>
						<h6 class="text-2xl font-medium sm:text-3xl">
							{{ internationalNoFormat(item.total) }}
						</h6>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>
